import { render } from "./ImportLabelsModal.vue?vue&type=template&id=3add0db8&scoped=true"
import script from "./ImportLabelsModal.vue?vue&type=script&lang=js"
export * from "./ImportLabelsModal.vue?vue&type=script&lang=js"

import "./ImportLabelsModal.vue?vue&type=style&index=0&id=3add0db8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3add0db8"]])

export default __exports__